import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { ChevronDownIcon } from '../../Svg/Index.js'
import { SET_PROFILE_OPEN } from '../../Actions/Sidebar'
import { GET_GUILD_USERS } from '../../Actions/Guilds'

class UsersPopup extends Component {

    state = {
        users: []
    }

    componentDidMount() {
        this.refs.popup.classList.add('is-active');
        if(this.props.guild.activeGuild) {
            this.props.actions.GET_GUILD_USERS(this.props.guild.activeGuild._id).then(res => {
                this.setState({
                    users: res
                })
            })
        }
    }
    
    showProfile = (e, userId) => {
        if(e.target.classList.contains('c-btn')) return;
        this.props.actions.SET_PROFILE_OPEN(userId);
        this.props.closeUsersPopup();
    }

    render() {
        const { closeUsersPopup } = this.props;
        const { users } = this.state;
        return (
            <>
                <div className="c-popup" ref="popup">
                    <div className="c-popup__inner c-popup__inner--scrollable">
                        <div className="c-popup__buttons c-popup__buttons--absolute">
                            <button className="c-btn c-btn--compact c-popup__close" onClick={closeUsersPopup}><ChevronDownIcon /></button>
                        </div>
                        <span className="c-popup__title">Leden in deze groep ({users.length})</span>
                        <ul className="c-list c-list--alt">
                            {
                                users.map((item, i) => 
                                    <li className="c-list__item" onClick={(e) => this.showProfile(e, item._id)} key={`user-${item._id}}`}>
                                        <div className="c-list-user">
                                            <div className="c-list-avatar" style={{backgroundImage: `url(${item.avatar.user_avatar})`}}>
                                            </div>
                                            <span className="c-list-user__name">{item.display_name}</span>
                                        </div>
                                    </li>
                                )
                            }
                            </ul>
                    </div>
                </div>
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        guild: state.guilds,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({ GET_GUILD_USERS, SET_PROFILE_OPEN }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UsersPopup)